var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h1',[_vm._v(_vm._s(_vm.$t('menuItemPrint')))]),_c('printing-manager',{staticClass:"pt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }